import React, { useEffect, useState } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import Path from "../../common/Path";
import AboutService from "../../services/AboutService";
import { useSelector } from "react-redux";
import imgSrc from "../../assets/about-img.jpg";
import bg from "../../assets/bg.jpg";

const AboutUs = () => {
	const { t } = useTranslation();
	const [about, setAbout] = useState([{}, {}, {}]);
	const lang = useSelector((state) => state?.lang?.lang);
	const aboutService = new AboutService();

	useEffect(() => {
		aboutService?.getList({ type: "about" }).then((res) => {
			if (res?.status === 200) {
				setAbout(res?.data?.data);
			}
		});
	}, []);

	return (
		<div className="main-page">
			<div
				className="banner"
				style={{
					backgroundImage: `url(${bg})`,
				}}>
				<p className="title">{t("about-us")}</p>
				<p className="sub-title">{t("Know more about Us")}</p>
			</div>
			<div className="static">
				<div className="container">
					<div className="about">
						{about?.map((res, index) => {
							return (
								<div
									className={`about-card mb-4 ${
										index % 2 === 0 ? "one" : "two"
									}`}>
									{index % 2 === 0 ? (
										<>
											<img src={res?.image || imgSrc} alt="about" />
											<div className="details">
												<p
													className="details-title"
													dangerouslySetInnerHTML={{
														__html: t(res?.title),
													}}></p>
												<p
													className="details-description"
													dangerouslySetInnerHTML={{
														__html: t(res?.description),
													}}></p>
											</div>
										</>
									) : (
										<>
											<div className="details">
												<p
													className="details-title"
													dangerouslySetInnerHTML={{
														__html: t(res?.title),
													}}></p>
												<p
													className="details-description"
													dangerouslySetInnerHTML={{
														__html: t(res?.description),
													}}></p>
											</div>
											<img src={res?.image || imgSrc} alt="about" />
										</>
									)}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AboutUs;
